import { CircularProgress } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { useMobileApp } from '../../../../../../hooks/useMobileApp';
import { useDevices } from '../../../../../meeting/hooks/useDevices';

export const WaitingDisplay = () => {
  const { t } = useTranslation();
  const { requestDevices } = useDevices();
  const { isAppView } = useMobileApp();

  useEffect(() => {
    const previewVideo = document.getElementById('preview-video') as HTMLVideoElement;

    requestDevices()
      .then((mediaStream) => {
        previewVideo!.srcObject = mediaStream;

        previewVideo.onloadedmetadata = function (e) {
          previewVideo.play();
        };
        previewVideo.onplaying = function (e) {};
        previewVideo.onpause = function (e) {
          mediaStream.getTracks().forEach((x) => x.stop());
        };
      })
      .catch(() => {
        console.log('caught issue while initializing preview video of matching');
      });
  }, []);

  return (
    <div className="absolute w-full h-full flex items-center justify-between rounded-sm">
      <video
        id="preview-video"
        className="w-1/2 h-full"
        muted
        playsInline
        style={
          isAppView()
            ? {}
            : {
                transform: 'rotateY(180deg)',
              }
        }
      />
      <div className="w-1/2 h-full flex flex-col justify-center items-center">
        <CircularProgress />
        <div className="text-center">{t('meeting:speeddating.waiting')}</div>
      </div>
    </div>
  );
};
